import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate, useParams } from 'react-router-dom';
import Letter from '../../containers/Home/LetterPage'
import Cash from '../../containers/Home/CashPage'

const Home = () => {
    const login = window.localStorage.getItem('login')

    return (
        <React.Fragment>
            {login === 'cash' ? <Cash /> : <Letter />}
        </React.Fragment>
    )
}

Home.propTypes = {
    children: PropTypes.node
}

export default Home